import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { useSelector } from 'react-redux';

const computeAov = (revenue = [], orders = []) =>
  revenue.map((rev, i) => {
    const count = orders[i];
    return count ? Number((rev / count).toFixed(2)) : 0;
  });

const AovSplineArea = ({ splineGraph }) => {
  const { country = [] } = useSelector((state) => state.country);
  let cntry = country;
  if (cntry !== 'all' && cntry !== null) {
    cntry = cntry.toUpperCase();
  }

  const options = {
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
      width: 3,
    },
    grid: {
      borderColor: '#f1f1f1',
    },
    xaxis: {
      type: 'date',
      categories: splineGraph?.dates,
    },
    tooltip: {
      x: {
        format: 'dd-MM-yy',
      },
    },
  };

  if (cntry === 'all' && cntry !== 'AE') {
    const series = [
      {
        name: 'Total AE AOV',
        data: computeAov(splineGraph?.total_AE_revenue, splineGraph?.total_AE_orders),
      },
      {
        name: 'Total OM AOV',
        data: computeAov(splineGraph?.total_OM_revenue, splineGraph?.total_OM_orders),
      },
      {
        name: 'Total QA AOV',
        data: computeAov(splineGraph?.total_QA_revenue, splineGraph?.total_QA_orders),
      },
      {
        name: 'Total BH AOV',
        data: computeAov(splineGraph?.total_BH_revenue, splineGraph?.total_BH_orders),
      },
    ];

    return (
      <ReactApexChart
        options={{ ...options, colors: ['#556ee6', '#34c38f', '#f1be65', '#f47f7f'] }}
        series={series}
        type="area"
        height="350"
      />
    );
  }

  const series = [
    {
      name: 'Average Order Value',
      data: computeAov(splineGraph?.revenue, splineGraph?.no_orders),
    },
  ];

  return (
    <ReactApexChart
      options={{ ...options, colors: ['#f1be65'] }}
      series={series}
      type="area"
      height="350"
    />
  );
};

export default AovSplineArea;
